module.exports = __webpack_public_path__ + "img/CODAPAY_logo_A.v2.b9f18530.png";